import { FC } from "react"
import { useParams } from "react-router-dom"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"
import { PageHeader } from "../../common/ui"
import { RequireRole } from "../../common/validation"
import PricingEngineContainer from "../../common/ui/pricing-engine"

const PricingEnginePage: FC = () => {
  const { rateflowId } = useParams<{ rateflowId?: string }>()

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE["pricing-engine"]}>
      <div className="h-full flex flex-col">
        <div className="h-full py-6 bg-white">
          <div className="px-6">
            <PageHeader title="Pricing Engine" />
          </div>
          <div className="p-6 flex-1">
            <PricingEngineContainer initialRateflowId={rateflowId} />
          </div>
        </div>
      </div>
    </RequireRole>
  )
}

export default PricingEnginePage
